import {
  type UseSuspenseQueryResult,
  useSuspenseQuery,
} from '@tanstack/react-query';

import api from '@/axios';
import { GET_PURCHASE_PLANNING_KEY } from '@/keys';
import type { LotSizingWeekRange } from '@/types/core/lot-sizing/lot-sizing-week-range';
import type { Paginated } from '@/types/core/paginated';
import type { PurchasePlanning } from '@/types/core/purchase-planning/purchase-planning';
import type { DataTableQueryVariables } from '@/types/data-table';

type GetPurchasePlanningVariables = LotSizingWeekRange &
  DataTableQueryVariables<PurchasePlanning>;

export const getPurchasePlanning = async ({
  year,
  week,
  endYear,
  endWeek,
  page,
  perPage,
  sort,
  filters,
}: GetPurchasePlanningVariables): Promise<Paginated<PurchasePlanning>> => {
  const response = await api.get<Paginated<PurchasePlanning>>(
    '/purchase-plannings',
    {
      params: {
        year,
        week,
        endYear,
        endWeek,
        page,
        perPage,
        sort: JSON.stringify(sort),
        filters: JSON.stringify(filters),
      },
    },
  );
  return response.data;
};

export const useGetPurchasePlanning = ({
  year,
  week,
  endYear,
  endWeek,
  page,
  perPage,
  sort,
  filters,
}: GetPurchasePlanningVariables): UseSuspenseQueryResult<
  Paginated<PurchasePlanning>,
  Error
> =>
  useSuspenseQuery({
    queryKey: [
      ...GET_PURCHASE_PLANNING_KEY,
      year,
      week,
      endYear,
      endWeek,
      page,
      perPage,
      sort,
      filters,
    ],
    queryFn: () =>
      getPurchasePlanning({
        year,
        week,
        endYear,
        endWeek,
        page,
        perPage,
        sort,
        filters,
      }),
  });
